import Route from '@ember/routing/route';

export default class SmartphoneRoute extends Route {}
